module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/investments-fa44ab8de8863fcfed344eddfd56c9a6.jpg";